import { Component, inject } from '@angular/core';
import { ActivatedRoute, Params, Router, UrlCreationOptions } from '@angular/router';
import { SpinnerComponent } from '@sarasanalytics-com/design-system';
import { catchError, map, of, take } from 'rxjs';
import { Token } from 'src/app/app.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CookiesService } from 'src/app/services/cookies/cookies.service';
import { RedirectionService } from 'src/app/services/redirection/redirection.service';
import { SignupService } from 'src/app/services/signup/signup.service';
import { StoreService } from 'src/app/services/store/store.service';
import { IMessageView, MessageViewComponent, MessageViewEvent } from 'src/app/shared/components/message-view/message-view.component';
import { API_ERRORS } from 'src/app/static/api.constant';
import { NS_Enums } from 'src/app/static/namespace';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [SpinnerComponent, MessageViewComponent],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss'
})
export class AuthComponent {

  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private authService: AuthService = inject(AuthService);
  private store: StoreService = inject(StoreService);
  private signupService: SignupService = inject(SignupService);
  private redirectionService: RedirectionService = inject(RedirectionService);
  private cookieService: CookiesService = inject(CookiesService);
  private redirectURL: string;
  private productType: string;

  messageView: IMessageView | null;

  isLoading: boolean = true;
  
  ngOnInit(){
    setTimeout(()=>{
      this.redirectURL = this.route.snapshot.queryParamMap.get('redirectTo') || '';
      this.productType = this.route.snapshot.queryParamMap.get('productType') || '';

      this.checkLoginAndRedirect();
    }, 0);
  }

  checkLoginAndRedirect(){
    
    /* CHECK IF USER FROM DATON / PULSE SIGNED OUT
       * IF GLOBAL TOKEN IS NULL & USER IS STILL SIGNED IN
    */
    const saras_global = this.cookieService.get(NS_Enums.saras_global) || null;
    if(!saras_global && this.authService.isLoggedIn){
      this.authService.logOut();
      return;
    }


    if(this.productType){
      this.authService.isAuthenticated().pipe(take(1)).subscribe((isAuthenticated)=>{
        const token = this.store.getToken();
        const queryParams: Params = {
          'redirectTo': this.redirectURL,
          'productType': this.productType
        };
        if(isAuthenticated && token){

          this.signupService.verifyFirebaseToken(token).subscribe((res: any)=>{
            if(res.success && res.data){
              const token: Token = res.data;
              const userId = token?.userId;

              /* GET USER DATA */
              this.signupService.getUserInfo(userId).subscribe((userInfoRes)=>{
                if(userInfoRes.success && userInfoRes.data){
                  this.cookieService.addSharedCookie(token);
                  this.redirectionService.redirectToProduct();
                }else{
                  this.handleError(res || API_ERRORS.defaultError, queryParams);
                }
              })
            }else{
              this.handleError(res || API_ERRORS.defaultError, queryParams);
            }
          })
        }else{
          this.authService.logOut();
          this.handleError(API_ERRORS.defaultError, queryParams);
        }
      })
    }else{
      this.handleError();
    }
  }
  handleError(response: any = null, queryParams: any = {}){
    this.isLoading = false;
    if(response){
      const code: string = response?.code || 'DEFAULT';
      const errMsg = response?.code ? '' : (response?.errors?.message || '');
      /*@ts-ignore*/
      const message = errMsg || API_ERRORS.FIREBASE_MESSAGES[code] || API_ERRORS.FIREBASE_MESSAGES.DEFAULT;
      this.messageView = {
        state: 'failure',
        title: message,
        items: [
          {
            type: 'BUTTON',
            text: 'Login',
          }
        ]
      }
    }
    this.router.navigate(['login'], {queryParams});
  }

  onMessageViewEvent(evt: any) {
      switch (evt.type) {
        case MessageViewEvent.REFRESH:
          break;
        case MessageViewEvent.RESEND:
          break;
        case MessageViewEvent.BUTTON:
          this.authService.logOut();
          break;
      }
  }

  handleMessageViewClick(event: any){
    
  }
}
